import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store/";
import "./registerServiceWorker";

import globalComputed from "./mixins/global/globalComputed.js";
import globalMethods from "./mixins/global/globalMethods.js";

// ImageUploader component (3rd party)
import ImageUploader from "vue-image-upload-resize";
Vue.use(ImageUploader);

Vue.mixin({
  mixins: [globalComputed, globalMethods]
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
